import type { ReactNode } from "react";
import sanitizeHtml from "sanitize-html";
import type { Product } from "@/graphql/storefront/generated";
import { parseRichText, renderRichTextNode } from "@/utils/richText";

export const accessoryDescriptionClassName =
  "font-ppMori text-[14px] leading-[1.6] tracking-[-0.28px] text-[#54524e] [&_a]:underline [&_p]:text-[14px] [&_p]:leading-[1.6]";

export function getAccessoryMetafieldValue(product: Product, key: string) {
  return (
    product.metafields?.find((metafield) => metafield?.key === key)?.value ??
    null
  );
}

export function renderAccessoryPrimaryDescription(
  product: Product,
  className: string,
): ReactNode {
  if (!product.descriptionHtml) return null;

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: normalizeAccessoryDescriptionHtml(product.descriptionHtml),
      }}
    />
  );
}

export function renderAccessoryAdditionalDescription(
  description: string | null,
  className: string,
): ReactNode {
  const parsedDescription = parseRichText(description);

  if (!parsedDescription) return null;

  return (
    <div className={className}>{renderRichTextNode(parsedDescription)}</div>
  );
}

function normalizeAccessoryDescriptionHtml(html: string) {
  return sanitizeHtml(html);
}
